/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {Function} from './function';

export class Zone extends BaseEntity {
  functions: Function[];
}
